import React, { useState, memo, useEffect, Fragment } from "react";
import axios from 'axios';
import { useRecoilState } from "recoil";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { hospitalState } from '../../../store/hospitalState';

import { PopoverText } from '../../common/parts/PopoverText';
import { PrefOptionList } from '../../common/parts/PrefOptionList';
import { OpenOptionList } from '../parts/OpenOptionList';

export const HospitalBasicForm = (props) => {
  const { init_hospital } = props;
  const [hospitalData, setHospitalData] = useRecoilState(hospitalState);
  const [isDisabled, setIsDisabled] = useState(true);

  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true
      });
    } else {
      toast.error(message, {
        hideProgressBar: true
      });
    }
  }

  const onChangeData = (e) => {
    setHospitalData({
      ...hospitalData,
      [e.target.name]: e.target.value,
    });
  };

  const onChangeSwitchCheckbox = (e) => {
    if (e.target.name == "warning_flg") {
      setHospitalData({
        ...hospitalData,
        warning_flg: !hospitalData.warning_flg,
      });
    }  else if (e.target.name == "unable_agency_flg") {
      setHospitalData({
        ...hospitalData,
        unable_agency_flg: !hospitalData.unable_agency_flg,
      });
    } else if (e.target.name == "recommend_flg") {
      setHospitalData({
        ...hospitalData,
        recommend_flg: !hospitalData.recommend_flg,
      });
    }
  }

  const onClickHospitalUpdate = () => {
    console.log("onClickHospitalUpdate!");
    setIsDisabled(false);
    var data = { hospital: { ...hospitalData }};

    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.patch(`/agent/hospitals/${hospitalData.id}`, data)
    .then(resp => {
      console.log("Hospital Update api ok");
      // console.log(resp.data);
      setHospitalData({
        ...hospitalData,
        full_address: resp.data.full_address,
        updated_at: resp.data.updated_at,
      });
      notify("success", "Hospital Update Success!");
    })
    .catch(e => {
      console.log("Hospital Update api ng");
      console.log(e.response);
      setHospitalData({ 
        ...hospitalData,
        name: init_hospital.name,
        abbr_name: init_hospital.abbr_name,
        hospital_code: init_hospital.hospital_code,
        zipcode: init_hospital.zipcode,
        prefecture_code: init_hospital.prefecture_code,
        area: init_hospital.area,
        address: init_hospital.address,
        full_address: init_hospital.full_address,
        represent_tel: init_hospital.represent_tel,
        direct_tel: init_hospital.direct_tel,
        pr_tel: init_hospital.pr_tel,
        represent_fax: init_hospital.represent_fax,
        direct_fax: init_hospital.direct_fax,
        pr_fax: init_hospital.pr_fax,
        email: init_hospital.email,
        url: init_hospital.url,
        mon_open: init_hospital.mon_open,
        tue_open: init_hospital.tue_open,
        wed_open: init_hospital.wed_open,
        thu_open: init_hospital.thu_open,
        fri_open: init_hospital.fri_open,
        sat_open: init_hospital.sat_open,
        sun_open: init_hospital.sun_open,
        holiday_open: init_hospital.holiday_open,
        memo: init_hospital.memo,
        access_memo: init_hospital.access_memo,
        hospital_memo: init_hospital.hospital_memo,
        contract_memo: init_hospital.contract_memo,
        option_memo: init_hospital.option_memo,
        work_memo: init_hospital.work_memo,
        gastroscope_state: init_hospital.gastroscope_state,
        gastroscope_memo: init_hospital.gastroscope_memo,
        contract_state: init_hospital.contract_state,
        contract_state_memo: init_hospital.contract_state_memo,
        warning_flg: init_hospital.warning_flg,
        unable_agency_flg: init_hospital.unable_agency_flg,
        recommend_flg: init_hospital.recommend_flg,
      });
      alert(JSON.parse(e.request.responseText).errors);
      notify("error", "Hospital Update Error!");
    })
    .finally(()=> {
      setIsDisabled(true);
    });
  }

  return (
    <>
      <ToastContainer />
      <div className="card mt-3">
        <div className="card-header">
          <div className="row">
            <div className="col-auto me-auto h4 mt-1">基本情報</div>
            <div className="col-4">
              <div className="input-group">
                <span className="input-group-text" id="title-basic-updated_at">更新日：</span>
                <input type="text" className="form-control" id="basic-updated_at" value={hospitalData.updated_at} disabled />
              </div>
            </div>
          </div>
        </div>

        <div className="card-body">
          <div className="row">
            <div className="col-6">
              <div className="input-group mb-3">
                <span className="input-group-text" id="title-basic-name">医療機関名</span>
                <input type="text" name="name" className="form-control" id="basic-name" value={hospitalData.name} onChange={onChangeData} />
              </div>
            </div>
            <div className="col-3">
              <div className="input-group mb-3">
                <span className="input-group-text" id="title-basic-abbr_name">略名</span>
                <input type="text" name="abbr_name" className="form-control" id="basic-abbr_name" value={hospitalData.abbr_name} disabled />
              </div>
            </div>
            <div className="col-3">
              <div className="input-group mb-3">
                <span className="input-group-text" id="title-basic-hospital_code">医療ID</span>
                <input type="text" name="hospital_code" className="form-control" id="basic-hospital_code" value={hospitalData.hospital_code} disabled />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col">
              <div className="input-group mb-3">
                <span className="input-group-text" id="title-basic-prefecture_code">所在地
                  <a href={`https://www.google.com/maps/search/?api=1&query=${hospitalData.full_address}`} target="_blank" rel="noopener noreferrer">
                    <i className="fa fa-map text-primary" style={{cursor: 'pointer', marginLeft: '10px'}}></i>
                  </a>
                </span>
                <input type="text" name="zipcode" className="form-control" id="basic-zipcode" placeholder="郵便番号" defaultValue={hospitalData.zipcode} onChange={onChangeData} style={{width:'55px'}} />
                <select name="prefecture_code" className="form-select" id="basic-prefecture_code" defaultValue={hospitalData.prefecture_code} onChange={onChangeData} >
                  <PrefOptionList />
                </select>
                <input type="text" name="area" className="form-control" id="basic-area" placeholder="市区町村名" defaultValue={hospitalData.area} onChange={onChangeData} />
                <input type="text" name="address" className="form-control" id="basic-address" placeholder="住所" defaultValue={hospitalData.address} onChange={onChangeData} />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col">
              <div className="input-group mb-3">
                <span className="input-group-text" id="title-basic-access_memo">アクセスメモ 
                  <PopoverText textTitle="アクセスメモについて" textBody="アクセスに関わるメモなどを記述してください。" />
                </span>
                <textarea type="text" name="access_memo" className="form-control" id="basic-access_memo" cols="30" rows="1" placeholder="例）内容 日付 担当者名" defaultValue={hospitalData.access_memo} onChange={onChangeData}></textarea>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <div className="input-group mb-3">
                <span className="input-group-text" id="title-basic-url">URL：</span>
                <input type="text" name="url" className="form-control" id="basic-url" defaultValue={hospitalData.url} onChange={onChangeData} />
              </div>
            </div>
            <div className="col-6">
              <div className="input-group mb-3">
                <span className="input-group-text" id="title-basic-email">Email</span>
                <input type="text" className="form-control" name="email" id="basic-email" defaultValue={hospitalData.email} onChange={onChangeData} />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-4">
              <div className="input-group mb-3">
                <span className="input-group-text" id="title-basic-represent_tel">代表TEL</span>
                <input type="text" className="form-control" name="represent_tel" id="basic-represent_tel" defaultValue={hospitalData.represent_tel} onChange={onChangeData} />
              </div>
            </div>
            <div className="col-4">
              <div className="input-group mb-3">
                <span className="input-group-text" id="title-basic-direct_tel">直接TEL</span>
                <input type="text" className="form-control" name="direct_tel" id="basic-direct_tel" defaultValue={hospitalData.direct_tel} onChange={onChangeData} />
              </div>
            </div>
            <div className="col-4">
              <div className="input-group mb-3">
                <span className="input-group-text" id="title-basic-pr_tel">渉外TEL</span>
                <input type="text" className="form-control" name="pr_tel" id="basic-pr_tel" defaultValue={hospitalData.pr_tel} onChange={onChangeData} />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-4">
              <div className="input-group mb-3">
                <span className="input-group-text" id="title-basic-represent_fax">代表FAX</span>
                <input type="text" className="form-control" name="represent_fax" id="basic-represent_fax" defaultValue={hospitalData.represent_fax} onChange={onChangeData} />
              </div>
            </div>
            <div className="col-4">
              <div className="input-group mb-3">
                <span className="input-group-text" id="title-basic-direct_fax">直接FAX</span>
                <input type="text" className="form-control" name="direct_fax" id="basic-direct_fax" defaultValue={hospitalData.direct_fax} onChange={onChangeData} />
              </div>
            </div>
            <div className="col-4">
              <div className="input-group mb-3">
                <span className="input-group-text" id="title-basic-pr_fax">渉外FAX</span>
                <input type="text" className="form-control" name="pr_fax" id="basic-pr_fax" defaultValue={hospitalData.pr_fax} onChange={onChangeData} />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col">
              <div className="input-group mb-3">
                <span className="input-group-text" id="title-basic-gastroscope_state">胃カメラ</span>
                <select name="gastroscope_state" id="basic-gastroscope_state" className="form-select" defaultValue={hospitalData.gastroscope_state} onChange={onChangeData}>
                  <option value="0">不明</option>
                  <option value="1">可能</option>
                  <option value="2">不可</option>
                </select>
                <input type="text" name="gastroscope_memo" className="form-control w-50" id="basic-gastroscope_memo" placeholder="胃カメラメモ" defaultValue={hospitalData.gastroscope_memo} onChange={onChangeData} />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col">
              <div className="input-group mb-3">
                <span className="input-group-text" id="title-basic-contract_state">契約書有無</span>
                <select name="contract_state" id="basic-contract_state" className="form-select" defaultValue={hospitalData.contract_state} onChange={onChangeData}>
                  <option value="0">不明</option>
                  <option value="1">有り</option>
                  <option value="2">無し</option>
                </select>
                <input type="text" name="contract_state_memo" className="form-control w-50" id="basic-contract_state_memo" placeholder="契約書有無メモ" defaultValue={hospitalData.contract_state_memo} onChange={onChangeData} />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-4">
              <div className="form-check form-switch mb-3">
                <input className="form-check-input" type="checkbox" name="warning_flg" id="basic-warning_flg" checked={hospitalData.warning_flg} onChange={onChangeSwitchCheckbox} />
                <label className="form-check-label" htmlFor="basic-warning_flg">注意フラグ</label>
              </div>
            </div>
            <div className="col-4">
              <div className="form-check form-switch mb-3">
                <input className="form-check-input" type="checkbox" name="unable_agency_flg" id="basic-unable_agency_flg" checked={hospitalData.unable_agency_flg} onChange={onChangeSwitchCheckbox} />
                <label className="form-check-label" htmlFor="basic-unable_agency_flg">代行不可フラグ</label>
              </div>
            </div>
            <div className="col-4">
              <div className="form-check form-switch mb-3">
                <input className="form-check-input" type="checkbox" name="recommend_flg" id="basic-recommend_flg" checked={hospitalData.recommend_flg} onChange={onChangeSwitchCheckbox} />
                <label className="form-check-label" htmlFor="basic-recommend_flg">おすすめフラグ</label>
              </div>
            </div>
          </div>

          <table className="table table-bordered table-condensed mb-3">
            <thead>
              <tr className="bg-light">
                <th>月</th><th>火</th><th>水</th><th>木</th><th>金</th><th>土</th><th>日</th><th>祝</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <select name="mon_open" className="form-select" id="basic-mon_open" defaultValue={hospitalData.mon_open} onChange={onChangeData} >
                    <OpenOptionList />
                  </select>
                </td>
                <td>
                  <select name="tue_open" className="form-select" id="basic-tue_open" defaultValue={hospitalData.tue_open} onChange={onChangeData} >
                    <OpenOptionList />
                  </select>
                </td>
                <td>
                  <select name="wed_open" className="form-select" id="basic-wed_open" defaultValue={hospitalData.wed_open} onChange={onChangeData} >
                    <OpenOptionList />
                  </select>
                </td>
                <td>
                  <select name="thu_open" className="form-select" id="basic-thu_open" defaultValue={hospitalData.thu_open} onChange={onChangeData} >
                    <OpenOptionList />
                  </select>
                </td>
                <td>
                  <select name="fri_open" className="form-select" id="basic-fri_open" defaultValue={hospitalData.fri_open} onChange={onChangeData} >
                    <OpenOptionList />
                  </select>
                </td>
                <td>
                  <select name="sat_open" className="form-select" id="basic-sat_open" defaultValue={hospitalData.sat_open} onChange={onChangeData} >
                    <OpenOptionList />
                  </select>
                </td>
                <td>
                  <select name="sun_open" className="form-select" id="basic-sun_open" defaultValue={hospitalData.sun_open} onChange={onChangeData} >
                    <OpenOptionList />
                  </select>
                </td>
                <td>
                  <select name="holiday_open" className="form-select" id="basic-holiday_open" defaultValue={hospitalData.holiday_open} onChange={onChangeData} >
                    <OpenOptionList />
                  </select>
                </td>
              </tr>
            </tbody>
          </table>

          <div className="row">
            <div className="col">
              <div className="input-group mb-3">
                <span className="input-group-text" id="title-basic-memo">お知らせ 
                  <PopoverText textTitle="お知らせについて" textBody="医療機関の全体に関わるメモなどを記述してください。" />
                </span>
                <textarea type="text" name="memo" className="form-control" id="basic-memo" cols="30" rows="5" placeholder="例）2022年に◯◯クリニックと統合。（年月日 担当者名＠クライアント名）" defaultValue={hospitalData.memo} onChange={onChangeData}></textarea>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <div className="input-group mb-3">
                <span className="input-group-text" id="title-basic-hospital_memo">健診メモ 
                  <PopoverText textTitle="健診メモについて" textBody="健診全体に関わるメモなどを記述してください。" />
                </span>
                <textarea type="text" name="hospital_memo" className="form-control" id="basic-hospital_memo" cols="30" rows="5" placeholder="例）胃部検査ありのコースは午前、なしのコースは午後の受付になります。（年月日 担当者名＠クライアント名）" defaultValue={hospitalData.hospital_memo} onChange={onChangeData}></textarea>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <div className="input-group mb-3">
                <span className="input-group-text" id="title-basic-option_memo">OPメモ 
                  <PopoverText textTitle="オプションメモについて" textBody="オプションに関わるメモなどを記述してください。" />
                </span>
                <textarea type="text" name="option_memo" className="form-control" id="basic-option_memo" cols="30" rows="5" placeholder="例）婦人科は提携の△△クリニック（徒歩5分）で実施。（年月日 担当者名)" defaultValue={hospitalData.option_memo} onChange={onChangeData}></textarea>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <div className="input-group mb-3">
                <span className="input-group-text" id="title-basic-contract_memo">契約メモ 
                  <PopoverText textTitle="契約情報メモについて" textBody="医療機関選定の際のメモを記述してください。" />
                </span>
                <textarea type="text" name="contract_memo" className="form-control" id="basic-contract_memo" cols="30" rows="5" placeholder="例）必ず事前に渉外の〇〇様を通してから予約依頼すること。（年月日 担当者名)" defaultValue={hospitalData.contract_memo} onChange={onChangeData}></textarea>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <div className="input-group mb-3">
                <span className="input-group-text" id="title-basic-work_memo">結果表・請求書<br />郵送物関連メモ 
                  <PopoverText textTitle="結果表・請求表・郵送物関連メモについて" textBody="結果表・請求書・郵送物や業務化との連絡事項に関わるメモなどを記述してください。" />
                </span>
                <textarea type="text" name="work_memo" className="form-control" id="basic-work_memo" cols="30" rows="5" placeholder="例）結果票は原本のみKPあて送付 (年月日 担当者名@クライアント名)" defaultValue={hospitalData.work_memo} onChange={onChangeData}></textarea>
              </div>
            </div>
          </div>
        </div>

        <div className="card-footer text-center">
          <button 
            className="btn btn-primary text-white w-25" 
            onClick={onClickHospitalUpdate}
            disabled={
              isDisabled
              && hospitalData.name ? false : true
            }
          >
            内容更新
          </button>
        </div>
      </div>
    </>
  );
};